var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 18.0117C13.7783 18.0117 13.5566 17.93 13.3816 17.755L9.26327 13.6367C8.92494 13.2983 8.92494 12.7383 9.26327 12.4C9.6016 12.0617 10.1616 12.0617 10.4999 12.4L13.9999 15.9L17.4999 12.4C17.8383 12.0617 18.3983 12.0617 18.7366 12.4C19.0749 12.7383 19.0749 13.2983 18.7366 13.6367L14.6183 17.755C14.4433 17.93 14.2216 18.0117 13.9999 18.0117Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBlack);
export default __webpack_public_path__ + "static/media/chevron-black.16ba30bd0072b9a6960e2e0c9ac10cda.svg";
export { ForwardRef as ReactComponent };